import { changeOwnPasswordSchema, PASSWORD_MIN_LENGTH } from '@almacen/shared';
import { Button, Group, Modal, PasswordInput, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { api } from '../../api/client';
import { applyApiFieldErrors, zodValidator } from '../../lib/forms';
import { notifyError, notifySuccess } from '../../lib/notify';

export function ChangePasswordModal({ opened, onClose }: { opened: boolean; onClose: () => void }) {
  const [saving, setSaving] = useState(false);
  const form = useForm({
    initialValues: { currentPassword: '', newPassword: '' },
    validate: zodValidator(changeOwnPasswordSchema),
  });

  const handleClose = () => {
    form.reset();
    onClose();
  };

  const submit = form.onSubmit(async (values) => {
    setSaving(true);
    try {
      await api('/auth/password', { method: 'POST', body: values });
      notifySuccess('Contraseña actualizada. Se han cerrado sus otras sesiones.');
      handleClose();
    } catch (error) {
      if (!applyApiFieldErrors(form, error)) notifyError(error);
    } finally {
      setSaving(false);
    }
  });

  return (
    <Modal opened={opened} onClose={handleClose} title="Cambiar contraseña">
      <form onSubmit={submit}>
        <Stack>
          <PasswordInput
            label="Contraseña actual"
            autoComplete="current-password"
            {...form.getInputProps('currentPassword')}
          />
          <PasswordInput
            label="Nueva contraseña"
            description={`Mínimo ${PASSWORD_MIN_LENGTH} caracteres`}
            autoComplete="new-password"
            {...form.getInputProps('newPassword')}
          />
          <Group justify="flex-end">
            <Button variant="default" onClick={handleClose}>
              Cancelar
            </Button>
            <Button type="submit" loading={saving}>
              Guardar
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}
